/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"

import Header from "./header"
// import Footer from "./footer"
import "./layout.css"
import ScrollButton from "./scrollButton"

const Layout = ({ children }) => {

  return (
    <>
      <Header />
      
        <main>{children}</main>
      
      <ScrollButton />
      {/* <Footer /> */}
    </>
  )
}

export default Layout
